import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { ServiceMethods } from '@feathersjs/feathers';
import { TableColumn, VznDataTableComponent } from '@noammazuz/vzn-data-table';
import { VznFeathersService } from '@noammazuz/vzn-feathers';
import { MailList } from '../../models/mail-list';
import { Router } from '@angular/router';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { Template } from '@angular/compiler/src/render3/r3_ast';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-mail-list-table',
  templateUrl: './mail-list-table.component.html',
  styleUrls: ['./mail-list-table.component.scss']
})
export class MailListTableComponent implements OnInit {
  @ViewChild('deleteButtonTmpl', { static: true }) deleteButtonTmpl: TemplateRef<HTMLElement>;
  @ViewChild('table') table: VznDataTableComponent;
  mailListService: ServiceMethods<MailList>;

  query: any = {
    $sort: {
      createdAt: -1
    }
  };
  columns: TableColumn[];
  constructor(
    public translate: TranslateService,
    private feathers: VznFeathersService<MailList>,
    private router: Router,
    private dialog: MatDialog
    
  ) {
    this.translate = translate;
    this.mailListService = this.feathers.service('maillists');
  }

  ngOnInit(): void {
    this.columns = [
      { prop: 'name', name: this.translate.instant('MAIL-LIST-DETAILS.NAME'), filterType: 'like', cellTemplate: 'textTmpl'},
      { prop: 'contactCount', name: this.translate.instant('MAIL-LIST-DETAILS.CONTACTS'), cellTemplate: 'textTmpl'},
      { prop: 'contactCount', name: '', iconName: 'delete', customTemplate: this.deleteButtonTmpl }
    ];
  }

  maillistMapper(rows: any[]) {
    return rows.map(row => new MailList(row));
  }

  onDoubleClick(mailList: MailList) {
    this.router.navigate([`/mail-list-details/${mailList._id}`])
  }

  async deleteMailList(mailList: MailList) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      direction: this.translate.currentLang === 'he' ? 'rtl' :'ltr',
      data: {
        title: this.translate.instant('MAIL-LIST-DETAILS.DELETE_CONFIRMATION_TITLE'),
        body: this.translate.instant('MAIL-LIST-DETAILS.DELETE_CONFIRMATION_BODY')
      }
    });
    const res = await dialogRef.afterClosed().toPromise();
    if (res) {
      await this.mailListService.remove(mailList._id);
      this.table.setTableData();
    }
  }
}
